import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BuildingIcon, HelmetIcon } from '../../../components/icon/icon';

const JoinSelect = () => {
  return (
    <Container>
      <h1>
        가입 유형을 <br /> 선택해 주세요.
      </h1>
      <ul>
        <li className="user">
          <Link
            to={{
              pathname: '/join',
              state: { auth: 'join' },
            }}
          >
            <div className="icon-box">
              <HelmetIcon />
            </div>
            <p>
              기사 회원으로 가입
              <span>일감을 찾고 있어요.</span>
            </p>
          </Link>
        </li>
        <li className="company">
          <Link
            to={{
              pathname: '/joinCompany',
              state: { auth: 'join' },
            }}
          >
            <div className="icon-box">
              <BuildingIcon />
            </div>
            <p>
              회사 회원으로 가입
              <span>기사님을 찾고 있어요.</span>
            </p>
          </Link>
        </li>
      </ul>
    </Container>
  );
};

export default JoinSelect;

//styled
const Container = styled.div`
  padding: 0 2rem;
  h1 {
    margin: 5rem 0;
    font-size: 2.4rem;
    font-weight: 700;
  }
  ul {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    li {
      a {
        padding: 2.9rem 3rem;
        display: flex;
        gap: 2.3rem;
        border-radius: 1.6rem;
        font-size: 1.8rem;
        font-weight: 700;
        align-items: center;
        .icon-box {
          width: 3.4rem;
          height: 3.4rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        span {
          margin-top: 0.4rem;
          display: flex;
          font-size: 1.2rem;
          font-weight: 400;
        }
      }
    }
    li.user {
      a {
        background-color: ${(props) => props.theme.btnBlueColor};
        color: ${(props) => props.theme.textWhiteColor};
        .icon-box {
          svg {
            path {
              fill: ${(props) => props.theme.textWhiteColor};
              stroke: ${(props) => props.theme.textWhiteColor};
            }
          }
        }
        span {
          opacity: 0.6;
        }
      }
    }
    li.company {
      a {
        border: 1px solid ${(props) => props.theme.gray200};
        span {
          color: ${(props) => props.theme.gray500};
        }
      }
    }
  }
`;
